import React, { useEffect, useState } from 'react';
import {
  Paper,
  Stack,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import MyTableCell from '../material-ui/adaptive/MyTableCell';
import CusInput from '../material-ui/CusInput';
import CustomRadio from '../forms/theme-elements/CustomRadio';
import BtnTrash from '../bonus/ui/BtnTrash';
import CusButton from '../material-ui/CusButton';
import DeleteDialog from '../material-ui/dialog/DeleteDialog';
import Table from '../material-ui/adaptive/Table';
import CusTooltip from '../material-ui/CusTooltip';
import ShowContainer from '../material-ui/ShowContainer';

export default function CasinoDomainsTable({
  domains,
  setDomains,
  isDeleteModal,
  onDelete,
  prohibitDefaultDelete
}) {
  const { t } = useTranslation();

  const [openDeleteId, setOpenDeleteId] = useState(false);

  const onDeleteClick = (id) => {
    setDomains((prev) => {
      const newPrev = [...prev];
      const newDomains = newPrev.filter((_, indx) => indx !== id);
      if (newPrev[id].default) {
        if (newDomains[0]) newDomains[0].default = true;
      }
      return newDomains;
    });
    onDelete();
  };

  const onNewDomainClick = () => {
    setDomains((prev) => {
      const newPrev = [...prev];

      return [...newPrev, { name: '', default: !newPrev.length }];
    });
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <MyTableCell width="100%">
                <Stack gap={0.5} direction={'row'}>
                  <Typography>{t('Domains')}</Typography>
                  <CusTooltip text={'Domain without http(s)://'} />
                </Stack>
              </MyTableCell>
              <MyTableCell style={{ whiteSpace: 'nowrap' }} colSpan={2}>
                {t('Default')}
              </MyTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {domains.map((domain, indx) => (
              <TableRow key={indx}>
                <MyTableCell isLess>
                  <Stack>
                    <CusInput
                      value={domain.name}
                      width={'100%'}
                      onChange={(e) =>
                        setDomains((prev) => {
                          const prevInfo = JSON.parse(JSON.stringify(prev));
                          prevInfo[indx] = { ...prevInfo[indx], name: e.target.value };
                          return prevInfo;
                        })
                      }
                    />
                  </Stack>
                </MyTableCell>
                <MyTableCell isLess>
                  <CustomRadio
                    checked={domain.default}
                    onChange={() =>
                      setDomains((prev) => {
                        const prevInfo = JSON.parse(JSON.stringify(prev));
                        const newDomain = prevInfo.map((el) => ({ ...el, default: false }));
                        newDomain[indx] = { ...newDomain[indx], default: true };
                        return newDomain;
                      })
                    }
                  />
                </MyTableCell>
                <MyTableCell isLess>
                  <ShowContainer condition={!prohibitDefaultDelete || !domain.default}>
                    <BtnTrash
                      onDelete={() => (isDeleteModal ? setOpenDeleteId(indx) : onDeleteClick(indx))}
                    />
                  </ShowContainer>
                </MyTableCell>
              </TableRow>
            ))}

            <TableRow>
              <MyTableCell colSpan={3} isLess>
                <CusButton
                  fullWidth
                  variant="outlined"
                  text="Add new domain"
                  onClick={onNewDomainClick}
                />
              </MyTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <DeleteDialog
        open={openDeleteId || openDeleteId === 0}
        onClose={() => setOpenDeleteId(false)}
        onConfirm={() => onDeleteClick(openDeleteId)}
      />
    </>
  );
}
